import { memo, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Form } from 'antd';
import { routeFileSelector } from '@utilz/i18n';

import { FormSchema, useRegisterForm } from '@/modules/validators';

import FormInput from '../../../../../../components/Inputs/FormInput';
import FormTextArea from '../../../../../../components/Inputs/FormTextArea';
import SecondaryLabel from '../../../../../../components/Labels/SecondaryLabel';

const HallNotesDetails = () => {
  const [form] = Form.useForm();
  useRegisterForm(form, 'notesForm');
  const shipmentNote = Form.useWatch('quoteNotes', form);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data = {} } = useSelector((state) => state.shipment.shipmentDetails);
  const copyQuoteKey = useSelector((state) => state.common.copyQuoteKey);

  useEffect(() => {
    if (copyQuoteKey) {
      form.setFieldValue('quoteNotes', data?.quoteNotes);
      form.setFieldValue('costCenter', data?.costCenter);
    }
  }, [copyQuoteKey, form, data?.costCenter, data?.quoteNotes]);

  return (
    <Form name="notesForm" form={form}>
      <FormSchema.Field name="costCenter">
        {({ name, antdRule, isRequired, label }) => (
          <FormInput
            name={name}
            label={label}
            editMode
            className="w-50"
            isRequired={isRequired}
            rules={[antdRule]}
            dataTestId="cost-center-input"
          />
        )}
      </FormSchema.Field>
      <FormSchema.Field name="quoteNotes">
        {({ name, antdRule, isRequired }) => (
          <FormTextArea
            name={name}
            placeholder={`${t('translation:getQuote.notesHere')}...`}
            editMode
            margin="mb-0"
            rows={10}
            isRequired={isRequired}
            rules={[antdRule]}
            dataTestId="quote-notes-input"
          />
        )}
      </FormSchema.Field>
      <SecondaryLabel className="f16" dataTestID="quote-notes-input-char-num">
        {2000 - (shipmentNote ? shipmentNote?.length : 0)} {t('translation:getQuote.characters')}
      </SecondaryLabel>
    </Form>
  );
};

export default memo(HallNotesDetails);
